import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {ProcessService} from '../../../services/process.service';
import {switchMap} from 'rxjs/operators';
import {NgxTimelineEventChangeSide} from "@frxjs/ngx-timeline";

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TimelineComponent implements OnInit {
    process: any;
    constructor(private route: ActivatedRoute, private processService: ProcessService) {
    }
    events = null
    ngOnInit() {
        if (this.route.snapshot.paramMap.get('id')) {
            this.route.paramMap.pipe(
                switchMap((params: ParamMap) => this.processService.getProcess(params.get('id'))))
                .subscribe(process => {
                    setTimeout(() => {
                        this.process = process
                        let approveDate = null
                        this.events = this.process?.tasks?.map( p => {
                            if (p.approveDate) approveDate = new Date(p.approveDate)
                            if (!approveDate) approveDate = new Date();
                            return {timestamp: approveDate, isApproved: p.approveDate != null, title: p.step, description: p.name, key: p.key, status: p.status}
                        })
                    },200);
                });
        }
    }

    /**
     * The status dots are painted onto a <canvas>, and ctx.fillStyle cannot
     * take a var() -- so the values are read out of the design tokens here
     * instead of being written as hexes that would drift from them.
     */
    private token(name: string, fallback: string): string {
        const value = getComputedStyle(document.documentElement).getPropertyValue(name);
        return (value || '').trim() || fallback;
    }

    getColor(taskStatus) {
        if (taskStatus === 'ONGOING') {
            return this.token('--navy-600', 'rgb(44 66 114)');
        }
        if (taskStatus === 'DRAFT') {
            return this.token('--fg-3', 'rgb(107 114 128)');
        }
        if (taskStatus === 'APPROVED') {
            return this.token('--success', 'rgb(22 163 74)');
        }
        if (taskStatus === 'SUBMITTED') {
            return this.token('--warning', 'rgb(202 138 4)');
        }
        if (taskStatus === 'ASSIGNED') {
            return this.token('--navy-400', 'rgb(124 138 168)');
        }
        return this.token('--fg-1', 'rgb(17 24 39)');
    }

    drawCircle(canvasId, color){
        const canvas = document.getElementById(canvasId)
        // @ts-ignore
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = color
        ctx.beginPath()
        ctx.arc(15,15,15,0,Math.PI*2,true)
        ctx.closePath()
        ctx.fill()
        console.log(canvasId, color)
    }

    protected readonly NgxTimelineEventChangeSide = NgxTimelineEventChangeSide;
}



